import React from 'react'
import HeaderSearch from '../components/common/headerSearch'
import Icons from '../components/common/icons'
import { useLayoutStore } from '../store/layoutStore'

const ResponsiveHeader = () => {
  const { setExpand, expand } = useLayoutStore()

  return (
    <div className="w-full flex gap-2 py-2 px-5 items-center border-b border-formBorder">
      <div
        onClick={() => setExpand(!expand)}
        className="size-8 shrink-0 rounded-sm flex items-center justify-center border-grey-light border fill-grey-medium md:hidden cursor-pointer"
      >
        <Icons name="hamburger-icon" className="block size-4" />
      </div>
      <HeaderSearch />
    </div>
  )
}

export default ResponsiveHeader
